import { requestHandler } from 'core/services/httpRequest';

export const getCheckInDetails = (pgId) => {
  return requestHandler.GET({url: `/checkin/${pgId}`});
};

export const getSharingTypes = (pgId) => {
  return requestHandler.GET({url: `/checkin/${pgId}/sharingTypes`});
};

export const getAvailableRooms = (pgId, sharingType, status = 'AVAILABLE') => {
  return requestHandler.GET({url: `/checkin/${pgId}/${sharingType}/${status}`});
};

export const submitCheckInDetails = (pgId, body = {}) => {
  return requestHandler.POST({url: `/checkin/${pgId}`, body});
};

export const getUserProfileDtails = (mobileNumber, params) => {
  return requestHandler.GET({url: `/checkin/user/${mobileNumber}`, params});
};

export const sendCheckInOtp = (mobileNumber) => {
  return requestHandler.GET({url: `/user/${mobileNumber}/sendOtp`});
};

export const validateCheckInOtp = (data) => {
  return requestHandler.GET({url: '/user/validateOtp', params: {...data}});
};

export const submitTenantProfile = (body = {}) => {
  return requestHandler.POST({url: '/checkin/tenant', body});
};

export const uploadTenantDocument = (body = {}) => {
  return requestHandler.FILEUPLOAD({url: '/checkin/tenant/document', body});
};

export const validateCheckInBooking = (pgId, inmateUuid) => {
  return requestHandler.GET({url: `/checkin/${pgId}/booking`, params: {inmateUuid}});
};
